import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function ProductAccessModal({ id, cancelModal }) {
  const [isLoading, setIsLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [events, setEvents] = useState([]);
  const { user } = useAuthContext();
  //styled
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const headers = user ? { Authorization: `Bearer ${user.token}` } : {};

      const productResponse = await axios.get(
        `${ApiConnectionString}/api/product/${id}`,
        { headers }
      );
      setProduct(productResponse.data);

      const accessResponse = await axios.get(
        `${ApiConnectionString}/api/ProductAccess/${id}`,
        { headers }
      );

      if (accessResponse.status === 200) {
        setEvents(accessResponse.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">{product.name}</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <p>{product.name} allows access to the classes listed below.</p>

          <table class="custom-table">
            <thead class="blueBanner">
              <tr>
                <th>Class</th>
                <th>Day</th>
                <th>Times</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td>{event.name}</td>
                  <td>{event.day}</td>
                  <td>
                    {event.timeIn} - {event.timeOut}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <ul></ul>
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
